<template>
    <div>
        <b-modal
                id="modify-customer-details-popup"
                ref="modal"
                title="Customer Details"
                size="lg"
                hide-footer
                modal-class="hide-footer"
                no-close-on-backdrop
                :hide-header-close="loading"
                no-close-on-esc
                @hidden="onHidden"
        >
            <b-form
                    @submit.stop.prevent="onSubmit()"
                    @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-8">
                        <b-form-group label="Customer Category/Type">
                            <b-form-select
                                    v-model="formData.type"
                                    :options="options"
                                    placeholder="Select an Option"
                                    v-validate="{
                                    required: true,
                                }"
                                    class="form-control"
                                    name="Customer Category/Type"
                                    :class="{
                                    'is-invalid': errors.has(
                                        'Customer Category/Type'
                                    ),
                                }"
                            ></b-form-select>
                        </b-form-group>
                    </div>

                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                            btn-label="Update"
                            btn-type="submit"
                            btn-variant="primary"
                            :class="loading ? 'disabled' : ''"
                            :disabled="loading"
                    ></base-button>
                    <base-button
                            btn-label="Cancel"
                            btn-type="reset"
                            :disabled="loading"
                            btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    const customerDetailsUpdateApi = new resource(
        'customers/update-customer-details'
    )
    import pdf from 'vue-pdf'

    import resource from '@/api/resource'
    import BaseFileInput from "../BaseFileInput";

    export default {
        components: {BaseFileInput,pdf},
        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                selectedPreviewItem: null,
                formData: this.initializeFormData(),
                options: [
                    { value: null, text: 'Select an Option', disabled: true },
                    { value: 'individual', text: 'Individual' },
                    { value: 'company', text: 'Company' },
                ],
            }
        },
        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters(['loading', 'selectedItem', 'hidePopup']),

            // title() {
            //     return this.selectedItem
            //         ? 'Modify ' + this.selectedItem.code + ' ' + 'Score'
            //         : 'Add Country of Residence Factor'
            // }, // End of title() method

            // buttonLabel() {
            //     return this.selectedItem ? 'Update' : 'Create'
            // },
        }, // End of Component > methods
        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
        watch: {
            /**
             * Handle when the selected has been updated
             *
             * @return {void}
             */
            selectedItem(value) {
                console.log('Selected Item at Watch : ', value)
                if (value !== null && value !== undefined) {
                    console.log('value', value)
                    this.formData.type = value.type ? value.type : "individual"

                    Object.assign(this.formData, value)
                } else {
                    this.onHidden()
                }
            },
            /**
             * Handle when the popup hide
             *
             * @return {void}
             */
            hidePopup(value) {
                if (value) {
                    this.onHidden()
                }
            },
        }, // End of Component > computed
        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {
            initializeFormData() {
                return {
                    type: '',
                }
            }, // End of initializeFormData() method
            /**
             * Handle when the modal is closed
             *
             * @return {void}
             */
            onHidden() {
                // clear the selected item
                this.$store.commit('clearItem')
                this.$store.commit('onSubmit', null)
                Object.assign(this.formData, this.initializeFormData())
                this.$validator.reset()
                this.$refs.modal.hide()
            }, // End of onHidden() method
            /**
             * Handle when the modal is canceled
             *
             * @return {void}
             */
            async onSubmit() {
                const result = await this.$validator.validateAll()
                if (result) {
                    // this.formData.customerVerificationStatus.nadra =
                    //     this.formData.verification
                    console.log('this.formData', this.formData)

                    try {
                        this.$store.commit('setLoading', true)
                        var { data } =
                            await customerDetailsUpdateApi.update(
                                this.formData.customerId,
                                this.formData
                            )
                        if (data) {
                            this.$toasted.show(data.message, {
                                duration: 2000,
                                type: ['success'],
                            })
                            this.onHidden()
                            this.$emit('statusUpdated', true)
                        }
                        this.$store.commit('setLoading', false)
                    } catch (error) {
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', error)
                    }
                } else {
                    this.$store.commit('setError', this.errors.all()[0])
                }
            }, // End of onSubmit() method
        }, // End of Component > watch
    }
</script>
